module.exports = __webpack_public_path__ + "img/koreanstyle.b5ce25fa.jpg";